import React, { useState } from 'react';

import MovieExisting from '../compObjects/MovieExisting';
import MovieNew from '../compObjects/MovieNew';

import Spinner from '../compUtils/Spinner';

import { useDispatch } from 'react-redux'
import { useObjectSelector, getObject } from '../redux/hooks'
import { useSelector } from 'react-redux'

import LazyLoad from 'react-lazyload';
import Icon from '../compUtils/Icon';


function MoviesPage(props) {

  const dispatch = useDispatch()
  const objectId = "/api/movies/"
  const moviesSelector = useObjectSelector(objectId)
  const movies = getObject(objectId, moviesSelector, dispatch)

  useObjectSelector("/api/movies/")
  const loginState = useSelector(store => store.loginReducer)
  const [createState, setCreateState] = useState({ state: 'NOCREATE' }) //CREATEPENDING, CREATEEDIT ; 



  return (
    <span >
      {
        movies() === "UNKNOWN"
          ?
          <Spinner />
          :
          <div class="columns is-multiline">

            {createState === "CREATEEDIT" ?
              <MovieNew setCreateState={setCreateState} createState={createState} />
              :
              loginState.logged ?
                <div class="column is-one-third">
                  <div class="box tile">
                    <a class="okwButton" onClick={() => setCreateState('CREATEEDIT')}>
                      <Icon name="plus" />
                    </a></div>
                </div>
                : ""
            }

            {movies().map((movie) => (
              <div class="column is-one-third">
                <LazyLoad height={200}>
                  <MovieExisting movieId={movie.id} />
                </LazyLoad>
              </div>

            ))}

          </div>
      }
    </span>
  );
}

export default MoviesPage;
